<template id="landing-pad">
  <v-app>
    <v-container class="admin">
      <v-card color="#4A6572" class="container" dark rounded>
        <v-container>
          <v-container class="row">
            <v-container class="columnLarge">
              <h1>Admin Login</h1>
              <v-form @submit.prevent="login">
                <v-text-field
                    v-model="username"
                    label="Email"
                    :error-messages="errorMessages"
                    required
                    @keyup.enter="login"
                ></v-text-field>
                <v-text-field
                    v-model="password"
                    label="Password"
                    type="password"
                    :error-messages="errorMessages"
                    required
                    @keyup.enter="login"
                ></v-text-field>
                <v-btn type="submit">Login</v-btn>
              </v-form>
              <v-alert
                  v-if="errorMessages.length > 0"
                  type="error"
                  dismissible
              >
                {{ errorMessages }}
              </v-alert>
            </v-container>
          </v-container>
        </v-container>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data() {
    return {
      username: '',
      password: '',
      errorMessages: ''
    };
  },
  methods: {
    async login() {
      try {
        await firebase.auth().signInWithEmailAndPassword(this.username, this.password);
        // Handle successful login
        this.$router.push('/edit'); // Redirect to dashboard after login
      } catch (error) {
        console.error("Login failed:", error.message);
        this.errorMessages = "Invalid username or password.";
      }
    }
  }
};
</script>


<style scoped>
.columnLarge h1 {
  margin-top: 0;
}

.container {
  height: auto;
  width: 70%;
  padding: 0;
}

.columnLarge {
  float: left;
  width: 100%;
  padding: 20px;
  margin: 30px;
}

.columnSmall {
  float: left;
  width: 30%;
  padding: 0;
}

.row {
  margin-top: 20px;
  padding: 0;
  min-width: 100%;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

@media screen and (max-width: 800px) {
  .columnLarge, .columnSmall {
    width: 100%;
    margin: 0;
  }

  .mobile-view {
    display: block;
  }

  .desktop-view {
    display: none;
  }

  #content-container {
    width: 90%;
  }

  #fb, #bottom-buttons, #bottom-buttons > * {
    width: 100%;
    height: auto;
    min-height: 60px;
    margin: 15px auto;
    float: none;
  }

  #fb {
    width: 50%;
  }
}

@media screen and (min-width: 800px) {
  .mobile-view {
    display: none;
  }

  .desktop-view {
    display: block;
    margin: 0;
    padding: 0;
  }
}

.mobile-menu {
  background-color: rgb(40, 51, 67) !important;
  list-style-type: none;
  margin: 0 3%;
}

.mobile-menu > * {
  text-decoration: none;
  display: block;
  margin: 15px 0;
  height: 60px !important;
  width: 100%;
}

.mobile-menu > * > * {
  font-size: 24px;
}
</style>